import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';
import type { OverrideValues, PaleState } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import { DistanceSlider, type DistanceSliderDispatchProps, type DistanceSliderStateProps } from './DistanceSlider';

export const mapStateToProps = ({ filters }: PaleState): DistanceSliderStateProps => ({
    id: 'distanceToCityFilter',
    label: 'Avstand til sentrum',
    min: 0,
    max: 5000,
    initialDistance: filters.distanceToCity ? filters.distanceToCity[1] : undefined,
});

export const mapDispatchToProps: OverrideValues<DistanceSliderDispatchProps, ActionCreator<unknown>> = {
    distanceChange: actions.filterDistanceToCity,
    triggerFetch: fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(DistanceSlider);
